import React from "react";
import clsx from "clsx";
import "./chat-box-input-buttons.styles.scss";

//@ts-ignore
import { ReactComponent as EmojiIcon } from "../../../assets/icons/Emoji.svg";
//@ts-ignore
import { ReactComponent as SendIcon } from "../../../assets/icons/Send.svg";

export interface ChatBoxInputButtonsProps {
	onClickSendButton?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	onClickSendStickerButton?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	className?: string;
}

const BlockName = "chat-box-input-buttons";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		Button: `${BlockName}__button`,
	},
} as const;

export type ChatBoxInputButtonsComponent = React.FC<ChatBoxInputButtonsProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxInputButtons = (props: ChatBoxInputButtonsProps) => {
	return (
		<div className={clsx(ChatBoxInputButtons.ClassNames.Block, props.className)}>
			<button
				className={ChatBoxInputButtons.ClassNames.Elements.Button}
				onClick={props.onClickSendStickerButton}
			>
				<EmojiIcon className="w-6 h-6 text-gray-800" />
			</button>
			<button
				className={clsx(ChatBoxInputButtons.ClassNames.Elements.Button, "--send")}
				onClick={props.onClickSendButton}
			>
				<SendIcon className="w-6 h-6" />
			</button>
		</div>
	);
};
ChatBoxInputButtons.ClassNames = ClassNames;
